/**
 * Minimal inline icon set for the design system (U5). 16×16 viewBox,
 * stroke = currentColor. No icon library dependency on purpose.
 */
import type { JSX, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement> & { size?: number };

function base(size: number | undefined, props: SVGProps<SVGSVGElement>): SVGProps<SVGSVGElement> {
  return {
    width: size ?? 16,
    height: size ?? 16,
    viewBox: '0 0 16 16',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
    ...props,
  };
}

export function IconChevronDown({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M3.5 6l4.5 4.5L12.5 6" />
    </svg>
  );
}

export function IconChevronLeft({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M10 3.5L5.5 8l4.5 4.5" />
    </svg>
  );
}

export function IconChevronRight({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M6 3.5L10.5 8L6 12.5" />
    </svg>
  );
}

export function IconClose({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M4 4l8 8M12 4l-8 8" />
    </svg>
  );
}

export function IconCheck({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M2.8 8.6l3.4 3.4 7-7.6" />
    </svg>
  );
}

export function IconAlert({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M8 2.2l6 10.6H2z" />
      <path d="M8 6.6v3" />
      <path d="M8 11.6v.01" />
    </svg>
  );
}

export function IconInfo({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <circle cx="8" cy="8" r="6" />
      <path d="M8 7.4v3.4" />
      <path d="M8 5v.01" />
    </svg>
  );
}

export function IconCalendar({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <rect x="2.2" y="3.2" width="11.6" height="10.6" rx="2" />
      <path d="M2.2 6.6h11.6M5.4 1.8v2.8M10.6 1.8v2.8" />
    </svg>
  );
}

export function IconUpload({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M8 10.5V2.8M4.8 5.8L8 2.6l3.2 3.2" />
      <path d="M2.5 10.8v1.4a1.6 1.6 0 001.6 1.6h7.8a1.6 1.6 0 001.6-1.6v-1.4" />
    </svg>
  );
}

export function IconPlus({ size, ...props }: IconProps): JSX.Element {
  return (
    <svg {...base(size, props)}>
      <path d="M8 3v10M3 8h10" />
    </svg>
  );
}
